import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Share2 } from "lucide-react";
import { api } from "@/lib/api";

const fmtDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });

export const ClientSharedReflections = ({ client }) => {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get(`/clients/${client.id}/shared-reflections`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [client.id]);

  if (!items || items.length === 0) return null;
  return (
    <div className="w-full mt-2" data-testid={`shared-reflections-${client.id}`}>
      <button type="button" onClick={() => setOpen((v) => !v)} className="text-xs font-bold uppercase tracking-widest text-slate-500 hover:text-indigo-700 flex items-center gap-1" data-testid={`shared-reflections-toggle-${client.id}`}>
        <Share2 className="w-3.5 h-3.5" /> Shared by client ({items.length}) {open ? "▴" : "▾"}
      </button>
      {open && (
        <ul className="mt-2 rounded-2xl bg-emerald-50/60 border border-emerald-100 p-4 space-y-2" data-testid={`shared-reflections-list-${client.id}`}>
          <li className="text-xs text-emerald-900">Reflections this client chose to share with you. They can un-share at any time.</li>
          {items.map((r) => (
            <li key={r.id} className="bg-white rounded-xl px-3 py-2 text-sm border border-emerald-100" data-testid={`shared-reflection-${r.id}`}>
              <p className="text-slate-800 italic">“{r.reflection}”</p>
              <p className="text-xs text-slate-400 mt-1">{fmtDate(r.local_date)} · <Link to={`/tutorials/${r.tutorial_id}`} className="hover:text-indigo-700">{r.tutorial_title}</Link> · {r.minutes} min</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
